import LForm from './LForm.vue'
import LFormItem from './LFormItem.vue'

export default (Vue) => {
  Vue.component(LForm.name, LForm)
  Vue.component(LFormItem.name, LFormItem)
}
